import FeedbackComponent from "./FeedbackComponent.jsx";
import KeyInformation from "./KeyInformation.jsx";
import TotalAttendees from "./TotalAttendees.js";
import UploadFiles from "./UploadFiles.jsx";
import useFormContext from "./useFormContext.js";
import useFormContextFamily from "../GetEventMarsComplete.jsx/useFormMarsComplete.js";

const SummaryRequestor = ({familyMode}) => {
    const { eventFormData } = familyMode==="false" ? useFormContext() : useFormContextFamily();

    const content = (
        <>
            <div className="col-md-10 mb-3">
                {/* Key Information */}
                <div className="container bg-light rounded p-2 mt-2 mb-1">
                    <KeyInformation eventId={eventFormData.eventId} />
                </div>

                {/* total attendees */}
                <div className="container bg-light rounded p-2 mt-2 mb-1">
                    <TotalAttendees familyMode={familyMode}></TotalAttendees>
                </div>

                {/* feedback */}
                <FeedbackComponent eventId={eventFormData.eventId} />

                {/* files upload and display  */}
                <UploadFiles familyMode={familyMode}></UploadFiles>
            </div>
        </>
    );
    return content;
};
export default SummaryRequestor;